import { render, staticRenderFns } from "./iCardVertical.vue?vue&type=template&id=1b10d5c9&scoped=true&"
import script from "./iCardVertical.vue?vue&type=script&lang=js&"
export * from "./iCardVertical.vue?vue&type=script&lang=js&"
import style0 from "./iCardVertical.vue?vue&type=style&index=0&id=1b10d5c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b10d5c9",
  null
  
)

export default component.exports